module.exports = "<p>\r\n  transient works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/account/transient/transient.component.html
// module id = ./src/app/pages/account/transient/transient.component.html
// module chunks = main